export interface OfferModification {
    code: string;
    visible: boolean;
    labels: OfferModificationLabel[];
    options: OfferModificationOption[];
}

export interface OfferModificationLabel {
    description: string;
    tooltip?: string;
    languageCode: string;
}

export interface OfferModificationOption {
    value: any;
    prices?: OfferModificationOptionPrice[];
    labels: OfferModificationLabel[];
    selected: boolean;
    coverages?: any[];
}

export interface OfferModificationOptionPrice {
    value: number;
    frequency: PriceFrequency;
}

export enum PriceFrequency {
    ANNUALLY = 'ANNUALLY',
    SEMI_ANNUALLY = 'SEMI_ANNUALLY',
    QUARTERLY = 'QUARTERLY',
    MONTHLY = 'MONTHLY',
}
